/** Cognito errors surface their type on `.name` — used for both routing and messaging. */
export const errName = (e: unknown): string =>
  typeof e === 'object' && e !== null && 'name' in e ? String((e as { name: unknown }).name) : '';

/** Human-friendly copy for the common Cognito auth errors. */
export const friendlyAuthMessage = (e: unknown): string => {
  switch (errName(e)) {
    case 'NotAuthorizedException':
      return 'Incorrect email or password.';
    case 'UserNotFoundException':
      return 'No account found for that email.';
    case 'CodeMismatchException':
      return "That code doesn't match — check it and try again.";
    case 'ExpiredCodeException':
      return 'That code has expired — tap Resend for a new one.';
    case 'LimitExceededException':
      return 'Too many attempts — please wait a minute and try again.';
    case 'InvalidPasswordException':
      return 'Password must be at least 8 characters.';
    default:
      return e instanceof Error ? e.message : 'Something went wrong.';
  }
};
